class CollapsibleItems extends HTMLElement {
  constructor() {
    super();

    this.accordionHeaders = this.querySelectorAll('.accordion-header');

    this.accordionHeaders.forEach(header => {
      header.addEventListener('click', () => {
        const item = header.parentElement;
        const accordion = item.parentElement;

        accordion.querySelectorAll('.accordion-item').forEach(i => {
          if (i !== item) i.classList.remove('active');
        });

        item.classList.toggle('active');
      });
    });
  }
}

customElements.define('collapsible-items', CollapsibleItems);